import React from 'react';
import SelectPopup from './SelectPopup';
import { testModule as test } from '../../../service/command';
import { filterDetectModules } from '../../../js/utils';

const modules = [
  'rtc',
  'radar',
  'geo'
];

export default function Reboot() {
  const filterModules = filterDetectModules(modules);

  return (
    <SelectPopup
      title="测试组件"
      modules={filterModules}
      defaultSelectValue={filterModules[0]}
      onConfirm={(module) => {
        return test(module);
      }}
    />
  );
}
